import React from 'react';
import styles from './ProgramListItem.module.scss';
import TimeSpan from '../TimeSpan';
import RightChevron from '../RightChevron';

function ProgramListItem(props) {
    const { className, startTime, endTime, break: isBreak, selectable, selected, selectableColor, onClick, onSelectSession, tabIcon, nextIcon, style, contentStyle, children } = props;

    return (
        <div className={[styles.ProgramListItem, className, isBreak ? styles.break : ''].join(' ')} onClick={onClick} style={style}>
            <div className={[styles.tab, isBreak ? styles.hideTab : ''].join(' ')}>
                {onSelectSession ? (
                    <button
                        type="button"
                        className={[selectable ? styles.selectable : null, selected ? styles.selected : ''].join(' ')}
                        style={{ backgroundColor: selectableColor }}
                        onClick={onSelectSession}>
                        {selectable ? <div className="icon" style={{}} /> : null}
                    </button>
                ) : tabIcon ? (
                    <div className={styles.tabIcon} style={{ backgroundColor: selectableColor }}>
                        {tabIcon}
                    </div>
                ) : null}
            </div>
            <TimeSpan className={[styles.time].join(' ')} start={startTime} end={endTime} startClassName={styles.start} endClassName={styles.end} style={contentStyle} />
            <div className={styles.content}>{children}</div>
            {nextIcon ? <RightChevron className={styles.next} /> : null}
        </div>
    );
}

export default ProgramListItem;
